import React, {
  useState,
} from 'react';
import {
  Input,
  Button,
  FormItem
} from '@mayo/mayo-ui-gakki';
import { Tags } from './common';
import {ReactComponent as CloseIcon} from '@common/assets/icon_times.svg';

export type JobLevelFormProps = {
  idx: number;
  jobLevels: string[];
  setJobLevels: (newJobLevels: string[]) => void;
}
export default function JobLevelForm(props: JobLevelFormProps) {
  const {
    idx,
    jobLevels,
    setJobLevels,
  } = props;
  const [inputValue, setInputValue] = useState(''); 
  const [errorMessage, setErrorMessage] = useState('');

  const handleAdd = () => {
    const isRepeat = jobLevels.find(s => s === inputValue);
    if (inputValue && !isRepeat) {
      const newData = [...jobLevels, inputValue];
      setJobLevels(newData);
      setInputValue('');
      setErrorMessage('');
    } else {
      if (isRepeat) {
        return setErrorMessage('職級不可相同');
      }
    }
  };

  const handleRemove = (i: number) => {
    const newData = [...jobLevels.slice(0, i), ...jobLevels.slice(i + 1, jobLevels.length)];
    setJobLevels(newData);
  };

  return (
    <div
      className={`z-10 border-black-300 border-b-[1px] bg-black-50 w-full origin-top transition-all px-[15px] pt-[15px] pb-2.5`}
      data-test-id={`job-level-form_${idx}`}
    >
      <div className={'grid grid-cols-[1fr,auto] gap-[15px] mb-2.5'}>
        <FormItem errorMessage={Boolean(errorMessage) ? errorMessage : ''}>
          <Input
            onChange={e => {
              setInputValue(e.currentTarget?.value)
              if (!e.currentTarget?.value) {
                setErrorMessage('');
              }
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.stopPropagation();
                handleAdd();
              }
            }}
            value={inputValue}
            isError={Boolean(errorMessage)}
            placeholder="請輸入職級 (非必填)"
            data-test-id={'job-level-input'}
          />
        </FormItem>
        <Button
          aria-label='add-job-level'
          variant={'outline'}
          colorSchema={'primary'}
          onClick={handleAdd}
          className={'add-btn whitespace-nowrap'}
        >
          新增
        </Button>
      </div>
      <div className="-ml-[5px]">
        {jobLevels.map((level, i) => {
          return (
            <Tags
              key={i}
              data-test-id={`job-level-${i}`}
              aria-label={`job-level-item-${i}`}
              className={'group'}
            >
              {level}
              <i
                className={`absolute h-[20px] w-[20px] flex items-center
                  justify-center cursor-pointer right-[5px]`}
                onClick={() => handleRemove(i)}
                data-test-id={`job-level-remove-btn-${i}`}
              >
                <Button
                  variant={'simple'}
                  colorSchema={'primary'}
                  icon={<CloseIcon className={'w-3 h-3 hidden group-hover:inline'}/>}
                />
              </i>
            </Tags>
          );
        })}
      </div>
    </div>
  );
}
